<template>
  <v-hover>
    <v-navigation-drawer
      id="app-drawer"
      v-model="visible"
      app
      dark
      slot-scope="{ hover }"
      :mini-variant="shouldMinimizeDrawer(hover)"
      hide-overlay
      stateless
    >
      <v-img :src="image" height="100%">
        <v-layout class="fill-height" tag="v-list" column>
          <!-- Header -->
          <v-list-tile avatar class="drawer-header-tile">
            <v-list-tile-avatar color="white">
              <v-img :src="logo" height="34" contain />
            </v-list-tile-avatar>
            <v-list-tile-title class="title-text">
              Messages Dashboard
            </v-list-tile-title>
          </v-list-tile>

          <!-- Expand/collapse toggle — always visible in both mini and full mode -->
          <v-list-tile
            class="v-list-item toggle-drawer-tile"
            @click.stop="changeDrawerMode()"
          >
            <v-list-tile-action>
              <v-icon color="white">
                {{ mini ? 'mdi-chevron-right' : 'mdi-chevron-left' }}
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-title class="white--text toggle-drawer-label">
              Minimize
            </v-list-tile-title>
          </v-list-tile>

          <v-divider />

          <v-list-tile
            v-for="(link, i) in getLinks()"
            :key="i"
            :to="link.to"
            :active-class="color"
            avatar
            class="v-list-item"
          >
            <v-list-tile-action>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title v-text="link.text" />
          </v-list-tile>

          <v-layout align-end>
            <v-layout column>
              <v-divider class="mb-0" />
              <v-list-tile @click="logOut" class="v-list-item mb-2 pl-0">
                <v-list-tile-action class="mr-2">
                  <v-icon>mdi-power</v-icon>
                </v-list-tile-action>
                <v-list-tile-content class="link-text">
                  Log Out
                </v-list-tile-content>
              </v-list-tile>
            </v-layout>
          </v-layout>
        </v-layout>
      </v-img>
    </v-navigation-drawer>
  </v-hover>
</template>

<script>
// Utilities
import { mapMutations, mapState } from "vuex";

export default {
  data() {
    const savedMini = localStorage.getItem("drawerMini");
    return {
    logo:
      "https://broadcastmessages.blob.core.windows.net/images/kisspng-iphone-imessage-messages-logo-computer-icons-message-5ac0960ddef172.5915598215225707659132.png",
    links: [
      {
        to: "/messages-new",
        icon: "mdi-message-text",
        text: "Messages New",
      },
      //   {
      //     to: "/messages",
      //     icon: "mdi-message-text",
      //     text: "Messages",
      //   },
      {
        to: "/calls",
        icon: "mdi-phone",
        text: "Calls",
      },
      {
        to: "/greetings",
        icon: "mdi-microphone",
        text: "Greetings",
      },
      {
        to: "/audio",
        icon: "mdi-animation-play",
        text: "Audio",
      },
      {
        to: "/questions",
        icon: "mdi-comment-question",
        text: "AI Questions",
      },
      {
        to: "/invoices",
        icon: "mdi-file-document",
        text: "AI Invoices",
      },
      {
        to: "/interviews",
        icon: "mdi-account-switch",
        text: "Interviews",
      },
      {
        to: "/talks",
        icon: "mdi-voice",
        text: "Talks",
      },
      {
        to: "/lemanyeidey",
        icon: "mdi-bullhorn-outline",
        text: "למען ידעו",
      },
      {
        to: "/logs",
        icon: "mdi-magnify",
        text: "Logs",
      },
      {
        to: "/kollel",
        icon: "mdi-volume-high",
        text: "Kollel Recordings",
      },
      {
        to: "/wercberger-hotline-messages",
        icon: "mdi-message",
        text: "Wercberger Messages",
      },
      {
        to: "/wercberger-hotline-calls",
        icon: "mdi-phone-log",
        text: "Wercberger Calls",
      },
    ],
    responsive: true,
    mini: savedMini !== null ? savedMini === "true" : true,
    };
  },
  watch: {
    responsive(newValue, oldValue) {
      this.mini = newValue;
    },
  },
  computed: {
    ...mapState("app", ["image", "color"]),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
    visible: {
      get() {
        return this.showDrawer();
      },
      set(val) {
        this.setDrawer(val);
      },
    },
    items() {
      return this.$t("Layout.View.items");
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    getLinks() {
      const normalizedUser = this.$store.state.user
        ? this.$store.state.user.toLowerCase().trim()
        : "";

      if (this.$store.state.user == "syw") {
        return [
          {
            to: "/recordings",
            icon: "mdi-volume-high",
            text: "Recordings",
          },
          {
            to: "/wercberger-hotline-calls",
            icon: "mdi-phone-log",
            text: "Wercberger Calls",
          },
          {
            to: "/wercberger-hotline-messages",
            icon: "mdi-message",
            text: "Wercberger Messages",
          },
        ];
      }

      if (["syw", "joel", "saul"].includes(normalizedUser)) {
        const linksWithRecordings = this.links.slice();
        const invoicesIndex = linksWithRecordings.findIndex(
          (link) => link.to == "/invoices"
        );
        const recordingsLink = {
          to: "/recordings",
          icon: "mdi-volume-high",
          text: "Recordings",
        };

        if (invoicesIndex >= 0) {
          linksWithRecordings.splice(invoicesIndex + 1, 0, recordingsLink);
        } else {
          linksWithRecordings.push(recordingsLink);
        }

        return linksWithRecordings;
      }

      return this.links;
    },
    showDrawer() {
      return ![null, "Login", "MessagesMobile", "CallsMobile"].includes(
        this.$route.name
      );
    },
    shouldMinimizeDrawer(hover) {
      if (!this.mini) return false;

      return !hover;
    },
    changeDrawerMode() {
      this.mini = !this.mini;
      localStorage.setItem("drawerMini", String(this.mini));
    },
    logOut() {
      this.$router.push({
        name: "Login",
      });
    },
  },
};
</script>

<style lang="scss">
#app-drawer {
  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }

  .v-image__image--contain {
    top: 9px;
    height: 60%;
  }

  .search-input {
    margin-bottom: 30px !important;
    padding-left: 15px;
    padding-right: 15px;
  }

  .title-text {
    font-weight: 400;
    font-size: 18px !important;
    margin-bottom: 5px;
    margin-top: 5px;
    font-family: Roboto, sans-serif !important;
    line-height: 1 !important;
  }

  .toggle-drawer-tile {
    opacity: 0.7;
    transition: opacity 0.2s;

    &:hover {
      opacity: 1;
    }
  }

  .toggle-drawer-label {
    font-size: 13px !important;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }
}
</style>
